function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIc404 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 271.455,
    height: 197.456,
    viewBox: "0 0 271.455 197.456",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "0pakv2y06a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5794",
    style: {
      fill: "none"
    },
    d: "M0 0h110.937v150.934H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2878"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4078",
    d: "M144.012 21.819a98.078 98.078 0 0 0-14.149 13.966 7.28 7.28 0 0 0 .359 9.69A21.277 21.277 0 0 1 114.968 81.6a7.278 7.278 0 0 0-7.2 6.5c-.049.446-.1.9-.136 1.342a97.923 97.923 0 0 0-.007 18.538 7.28 7.28 0 0 0 7.108 6.614 21.277 21.277 0 0 1 14.767 36.339 7.277 7.277 0 0 0-.482 9.7 98.011 98.011 0 0 0 13.966 14.149 7.279 7.279 0 0 0 9.69-.359 21.276 21.276 0 0 1 36.124 15.255 7.279 7.279 0 0 0 6.5 7.2 98 98 0 0 0 19.882.146 7.284 7.284 0 0 0 6.614-7.108 21.278 21.278 0 0 1 36.335-14.763 7.285 7.285 0 0 0 9.7.485 97.985 97.985 0 0 0 14.146-13.965 7.278 7.278 0 0 0-.356-9.692 21.278 21.278 0 0 1 15.257-36.129 7.275 7.275 0 0 0 7.192-6.5 98.015 98.015 0 0 0 .146-19.882 7.284 7.284 0 0 0-7.114-6.62 21.275 21.275 0 0 1-14.761-36.332 7.287 7.287 0 0 0 .484-9.7 98.055 98.055 0 0 0-13.968-14.144 7.272 7.272 0 0 0-9.687.357 21.279 21.279 0 0 1-36.127-15.259 7.274 7.274 0 0 0-6.5-7.192 97.88 97.88 0 0 0-19.878-.148 7.283 7.283 0 0 0-6.617 7.11A21.277 21.277 0 0 1 153.709 22.3a7.28 7.28 0 0 0-9.7-.482m76.73 41.8a38.1 38.1 0 1 1-38.7 5.4 37.973 37.973 0 0 1 38.7-5.4",
    transform: "translate(-89.377 .003)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4079",
    d: "M15.922 683.734a42.405 42.405 0 0 0-6.122 6.04 3.148 3.148 0 0 0 .155 4.19 9.2 9.2 0 0 1-6.6 15.623A3.147 3.147 0 0 0 .25 712.4a37.96 37.96 0 0 0-.059.58 42.351 42.351 0 0 0 0 8.016 3.148 3.148 0 0 0 3.074 2.86 9.2 9.2 0 0 1 6.383 15.713 3.147 3.147 0 0 0-.209 4.193 42.386 42.386 0 0 0 6.04 6.119 3.148 3.148 0 0 0 4.19-.155 9.2 9.2 0 0 1 15.621 6.6 3.148 3.148 0 0 0 2.812 3.111 42.381 42.381 0 0 0 8.6.063 3.15 3.15 0 0 0 2.86-3.074 9.2 9.2 0 0 1 15.713-6.384 3.15 3.15 0 0 0 4.194.21 42.358 42.358 0 0 0 6.117-6.039 3.147 3.147 0 0 0-.154-4.191 9.2 9.2 0 0 1 6.6-15.624 3.146 3.146 0 0 0 3.11-2.811 42.367 42.367 0 0 0 .063-8.6 3.15 3.15 0 0 0-3.074-2.86 9.2 9.2 0 0 1-6.383-15.711 3.151 3.151 0 0 0 .209-4.2 42.392 42.392 0 0 0-6.04-6.116 3.145 3.145 0 0 0-4.189.154 9.2 9.2 0 0 1-15.624-6.6 3.145 3.145 0 0 0-2.811-3.11 42.333 42.333 0 0 0-8.6-.064 3.15 3.15 0 0 0-2.861 3.075 9.2 9.2 0 0 1-15.713 6.382 3.148 3.148 0 0 0-4.193-.208m33.174 18.08a16.476 16.476 0 1 1-16.735 2.335 16.421 16.421 0 0 1 16.735-2.335",
    transform: "translate(0 -562.231)",
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4080",
    d: "M763.825 894.946h-72.408a6.155 6.155 0 0 1-3.093-11.479c15.787-9.025 31.12-23.98 25.719-46.947z",
    transform: "translate(-571.356 -697.492)",
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4081",
    d: "M840.789 316.551v.571a78.908 78.908 0 1 1 0-.571",
    transform: "translate(-569.334 -198.082)",
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4082",
    d: "M1237.058 442.32a78.985 78.985 0 0 1-78.982 78.416v-81.144l27.677-17.585-3.3-34.289z",
    transform: "translate(-965.606 -323.281)",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2856"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2855",
    style: {
      clipPath: "url(#0pakv2y06a)"
    },
    transform: "translate(137.002 46.52)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4083",
    d: "M1092.45 732.91v148.753a16.337 16.337 0 0 1-32.673 0V732.91z",
    transform: "translate(-1020.644 -657.622)",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4084",
    d: "M1092.45 767.375v14.056a38.634 38.634 0 0 1-32.674 0v-14.056z",
    transform: "translate(-1020.644 -686.359)",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4085",
    d: "M1003.273 414.476a38.537 38.537 0 1 1-62.923-29.84 2.726 2.726 0 0 1 4.444 2.118v26.1a33.908 33.908 0 0 0 39.882 0v-26.1a2.725 2.725 0 0 1 4.44-2.12 38.458 38.458 0 0 1 14.156 29.844",
    transform: "translate(-909.268 -366.714)",
    style: {
      fill: "#fff"
    }
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIc404);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-404.ec2b550bca257521f69680c3e85545ef.svg";